import {FC, HTMLProps, ReactNode, useCallback} from 'react';
import {useField} from 'formik';
import {Form} from '@components/Form';
import {InputGroup} from '@components/InputGroup';
import {FormControlProps} from 'react-bootstrap';

type Props = {};

export type HiddenInputProps = Props & { name: string };

export const HiddenInput: FC<HiddenInputProps> = ({name, ...props}) => {
    const [field, meta, actions] = useField(name);
    const {value, ...fieldRest} = field;

    const handleChange = useCallback(
        (e) => {
            actions.setValue(e.currentTarget.value);
        },
        [actions],
    );

    return (
        <Form.Control
            type={"hidden"}
            value={value}
            {...fieldRest}
            {...props}
            onChange={handleChange}
        />
    );
};
